import { findIndex } from 'lodash';
import { connect } from 'react-redux';

import PillToggle from 'components/PillToggle';
import { SUPPORTED_LOCALES } from 'constants/locales';
import ACTIONS from 'state/constants';
import CollectionPage from 'state/selectors/collection-page';
import Settings from 'utils/Settings';

const createTab = toggle => {
  const locale = Settings.currentLocale;
  // It's possible that the toggle doesn't have a relativeUrl for the current locale.
  // In that case, we should default to the EN_US url
  const url = toggle?.relativeUrl?.[locale] || toggle?.relativeUrl?.[SUPPORTED_LOCALES.EN_US];

  return {
    text: toggle?.label?.[locale] || '',
    href: url,
    handle: url?.substring(url.lastIndexOf('/') + 1),
  };
};

const mapStateToProps = (state, ownProps) => {
  const { leftPillToggle, rightPillToggle } = ownProps;
  const parentCollectionHandle = CollectionPage.getCollectionHandle(state);
  let tabs = [leftPillToggle, rightPillToggle].map(toggle => createTab(toggle));
  const activeIndex = findIndex(tabs, ['handle', parentCollectionHandle]);

  if (tabs?.some(tab => !tab?.text)) {
    tabs = [];
  }

  return {
    tabs,
    activeIndex,
  };
};

const mapDispatchToProps = dispatch => ({
  onClick: tab => {
    dispatch({
      type: ACTIONS.TRACK_COLLECTION_PILL_TOGGLE_CLICK,
      payload: {
        tab: tab,
      },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PillToggle);
